import { UIView } from '../views/ui-view';
import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import styles from './ui-tab.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIView}
 * @alias UITab
 * @element ui-tab
 * @implements {Activatable}
 * @classdesc Represents a class for <code>ui-tab</code> element.
 * Single tab element, should be child of ui-tabs container.
 * Can be only child of UITabs.
 * @property {string} [labelBadge] {@attr label-badge} Label for orange badge.
 * @property {string} [linkTo] {@attr link-to} Link for orange badge.
 * @property {"_self" | "_blank"} [target] {@attr target}
 * @property {boolean} [active] {@attr active} Make current tab active.
 * @property {boolean} [disabled] {@attr disabled} Disables a tab and prevents user interaction.
 * @slot
 * @example <ui-tab>Content here</ui-tab>
 */
@Component({ tag: 'ui-tab', styles })
export class UITab extends UIView {
    @Attribute(String) labelBadge?: string;
    @Attribute(String) linkTo?: string;
    @Attribute(String) target?: string;
    @Attribute(Boolean) disabled?: boolean;

    /**
     * @inheritDoc
     */
    override render(): void {
        this.setAttribute('role', 'tabpanel');
        if (!this.hasAttribute('tabindex')) {
            this.setAttribute('tabindex', '0');
        }
    }
}
